import { css } from 'styled-components';

export default {
  features: {
    materialOrder: {
      inputStyles: (theme) => css`
        background-color: ${theme.colors.materialOrder.searchBar.bg} !important;
        border: 1px solid ${theme.colors.materialOrder.searchBar.border} !important;
        &:focus {
          background-color: ${theme.colors.materialOrder.searchBar
            .activeBg} !important;
          border: 1px solid ${theme.colors.materialOrder.searchBar.activeBorder} !important;
        }
      `,
      containerPadding: (theme) => css`
        padding: ${`${theme.utils.pxToRem(20)}rem ${theme.utils.pxToRem(
          39,
        )}rem`};
      `,
    },
  },
};
